import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  basePath: "/docs",
  site: {
    title: "Compliance Assessment Service API Documentation",
    showPoweredBy: false,
    footer: {
      position: "center",
      copyright: `© ${new Date().getFullYear()} Precognox. All rights reserved.`,
      columns: [
        {
          title: "Product",
          position: "center",
          links: [
            {
              label: "Pricing",
              href: "https://www.precognox.com/pricing",
            }
          ]
        },
        {
          title: "Company",
          position: "center",
          links: [
            {
              label: "About Us",
              href: "https://www.precognox.com/about-us",
            },
            {
              label: "Contact",
              href: "https://precognox.com/about-us/#contact",
            }
          ]
        },
        {
          title: "Legal",
          position: "center",
          links: [
            {
              label: "Privacy Policy",
              href: "/privacy-policy",
            }
          ]
        }
      ]
    }
  },
  navigation: [
    {
      type: "category",
      label: "Overview",
      items: [
        {
          type: "doc",
          file: "overview/service-description",
          label: "Service Description",
          icon: "info",
        },
        {
          type: "doc",
          file: "overview/getting-started",
          label: "Getting Started",
          icon: "rocket",
        },
        {
          type: "doc",
          file: "overview/authentication",
          label: "Authentication",
          icon: "key",
        },
      ]
    },
    {
      type: "category",
      label: "Core Concepts",
      items: [
        {
          type: "doc",
          file: "core/assessment",
          label: "Assessment Process",
          icon: "clipboard-list",
        },
        {
          type: "doc",
          file: "core/content-processing",
          label: "Content Processing",
          icon: "file-text",
        },
        {
          type: "doc",
          file: "core/frameworks",
          label: "Frameworks",
          icon: "cog",
        },
        {
          type: "doc",
          file: "core/criteria",
          label: "Criteria",
          icon: "check-square",
        },
      ]
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
      icon: "code",
      badge: {
        "label": "v2.0",
        "color": "blue"
      },
      display: "always"
    }
  ],
  apis: {
    type: "file",
    input: "./apis/openAPI3_1.0.0.json",
    path: "/api",
    options: {
      examplesLanguage: "shell",
      disablePlayground: true,
      expandAllTags: true,
    },
  },
  redirects: [{ from: "/", to: "/overview/service-description" }],
  docs: {
    files: "/pages/**/*.{md,mdx}",
    defaultOptions: {
      copyPage: false,
    },
  }
};

export default config;
